import { StartImg } from "theme/start";
import { Back } from "theme/theme";

export const tecate = {
  home: {
    description: '¡COMPLETA TUS DATOS!',
    percentageProfile: 'Completo'
  },
  config: {
    prizes: '/prizes'
  },
  agegate: {
    title: '¡Bienvenido!'
  },
  legalage: {
    title: '¿ESTAS LISTO PARA LO QUE SE VIENE?'
  },
  start: {
    title: {
      html: <Back className={`flex flex-col flex-1 w-full justify-center sm:items-center`}>
        <div className="w-full flex flex-1 flex-col text-lg  font-bold text-center gap-4 items-center justify-evenly">
          <StartImg src={`${AZURE_BASE_URL}/fondo-inicial.svg`} alt="marca" className="max-w-full sm:max-w-sm" />
          <p className='px-7'>
            PÁSALA, PERO ANTES,<br />¿YA TE REGISTRASTE?
          </p>
        </div>
      </Back>
    }
  },
  signup: {
    title: 'YA QUEDÓ, ',
    description: 'Eres parte de Código Tecate, valida tu mail y checa tus correos para poder empezar a registrar tus códigos y ganar cosas chidas'
  },
  redeem: {
    description: <>Empieza a ganar {POINTS_NAME?.toLowerCase()}<br />y llévate premios únicos</>,
    description2: <>¿SABES ORAR? PUES ÓRALE, <br /> INGRESA TU CÓDIGO</>
  },
  congrats: {
    title: 'VEEEEENGA ',
    description: <div className="flex flex-col items-center justify-center text-center gap-3"><span>INGRESASTE 1 CÓDIGO NUEVO CON ÉXITO.</span><span>LAS ÁGUILAS QUE SUMAS PARA<br /> CANJEARLAS POR COSAS CHIDAS<br /> SON:</span></div>,
    button1: 'MIRA LOS PREMIOS',
    range: {
      title: 'VEEEEEEENGA ',
      description2: <>FELICITACIONES<br />HAS DESBLOQUEADO NUEVAS<br />COSAS EN CÓDIGO TECATE</>
    }
  },
  prizes: {
    head: {
      title: <>TUS {POINTS_NAME?.toLowerCase()}:</>,
      description: '¿Ya pensaste en qué las canjearás?'
    },
    exchange: {
      title: 'PÉRATE, PÉRATE',
      information: {
        button: 'QUIERO CONFIRMAR MIS DATOS',
        back: '¡VAMOS A ACTUALIZAR MIS DATOS!',
        confirm: {
          button: 'CANJEAR',
          back: 'VOLVER'
        }
      }
    },
    congrats: {
      description: <>Ahora atentx al mail que te vamos<br /> a mandar con toda la info del envío<br />de tu canje ¡Felicidades!</>
    }
  },
  trivias: {
    prefpicker: {
      title: 'Primero cuentanos tus preferencias',
      description: 'selecciona al menos tres categorías'
    }
  },
  auctions: {
    current: 'Puedes seguir mirando las otras ofertas mientras se termina la que ya ofertaste.'
  },
  refferal: {
    title: 'Código de referido de Tecate',
    text1: '¡Hola! ¡Usa mi código ',
    text2: ' y obtén una chance diaria para ganar el futbolito y otros premios en la nueva dinámica de Tecate!'
  }
}